import React from 'react';
import PropTypes from 'prop-types';
import abName from 'utils/abName';
import randomColor from 'utils/randomColor';
import './index.scss';

const Thumbnail = ({
  avatar,
  name,
  secondName,
  style,
  greenBubble,
}) => {
  return (
    <div className="thumbnail-wrapper" style={{ ...style }}>
      {avatar ? (
        <img src={avatar} alt="" className="thumbnail" />
      ) : (
        <div
          className="thumbnail"
          style={{ ...style, backgroundColor: randomColor() }}
        >
          <span>
            {!secondName ? abName(name) : abName(name, secondName)}
          </span>
        </div>
      )}
      {greenBubble && <span className="online-indicator" />}
    </div>
  );
};

Thumbnail.defaultProps = {
  secondName: null,
  style: {},
  avatar: '',
  name: '',
  greenBubble: false,
};

Thumbnail.propTypes = {
  avatar: PropTypes.string,
  name: PropTypes.string,
  secondName: PropTypes.string,
  style: PropTypes.objectOf(Object),
  greenBubble: PropTypes.bool,
};

export default Thumbnail;
